export default class developmentManager {
    constructor(){

        this.list = $(".l-development__list>ul>li");
        this.max = this.list.length - 1;
        this.index = 0;
        this.timer = 0;

    }
    set(_type,_target){

        let _this = this;

        function startTimer(){
            _this.timer = setInterval(function(){
                _this.change();
            },3000);
        }
        function stopTimer(){
            clearInterval(_this.timer);
            _this.timer = 0;
        }

        switch (_type) {
            case 'show': // --------------- show (start) --------------- //

                stopTimer();
                startTimer();

                break; // --------------- show (end) --------------- //

            case 'hide': // --------------- hide (start) --------------- //
                // motion

                stopTimer();

                break; // --------------- hide (end) --------------- //

            case 'click': // --------------- show (start) --------------- //

                stopTimer();
                _this.index = _target.parent('li').index();
                _this.list.removeClass('js__current');
                _target.parent('li').addClass('js__current');
                startTimer();

                break; // --------------- show (end) --------------- //
        }

    }
    change() {

        let _this = this;

        if (_this.index === _this.max) {
            _this.index = 0;
        } else {
            _this.index++;
        }
        _this.list.removeClass('js__current').eq(_this.index).addClass('js__current');
    }
}

